import * as types from './actionTypes'

export const getCont = (content) => ({
  type: types.GET_CONTENT,
  content
})



// WEBPACK FOOTER //
// ./src/actions/contentActions.js